import React, { useState, forwardRef } from 'react';
import Image from 'next/image';
import ThermoDefaultImg from '@/assets/images/cart/Thermo Fisher Scientific.svg';

interface IProps {
  product: any;
}
const ListImage = forwardRef<HTMLInputElement, IProps>(function ListImage(props, ref) {
  const { product } = props;
  const [imageError, setImageError] = useState(false);

  const onImageLoadError = (e) => {
    setImageError(true);
  };
  return (
    <>
      <Image
        src={product.itemImageUrlKey || ThermoDefaultImg}
        width={90}
        height={90}
        alt=""
        onError={onImageLoadError}
        className={`rounded-md border border-solid border-[#E5E5E5] sm:hidden ${imageError ? 'hidden' : ''}`}
      />
      <Image
        src={ThermoDefaultImg}
        width={90}
        height={90}
        alt=""
        className={`rounded-md border border-solid border-[#E5E5E5] sm:hidden ${imageError ? 'block' : 'hidden'}`}
      />
    </>
  );
});
export { ListImage };
